import { DataModel } from "../../../../lib/data/model/DataModel.js";

export class DegreeOfSaturationSrCalculationMethodModel extends DataModel {

    static _instance = null;

    static getInstance(authManager) {

        if (DegreeOfSaturationSrCalculationMethodModel._instance == null) DegreeOfSaturationSrCalculationMethodModel._instance = new DegreeOfSaturationSrCalculationMethodModel(authManager);
        return DegreeOfSaturationSrCalculationMethodModel._instance;

    }

    constructor (authManager) {

        super(authManager, 'geo-sections/degree-of-saturation-sr-calculation-methods', 'geo-sections/degree-of-saturation-sr-calculation-methods/codelist');

        this.entityName = 'geo-sections.DegreeOfSaturationSrCalculationMethod';
        this.privileges = {
            create: [["#admin"]],
            read: [["adminGeotechData"],["manageGeotechData"],["editGeotechData"],["readGeotechData"]],
            update: [["#admin"]],
            delete: [["#admin"]],
        };

        this.label = 'Degree Of Saturation Sr Calc Method';
        this.setLabel = 'Degree Of Saturation Sr Calc Methods';

        this.browser = {
            name: 'default-geo-sections-degreeofsaturationsrcalculationmethod-browser',
            moduleName: 'default-geo-sections-degreeofsaturationsrcalculationmethod-browser',
            moduleTitle: 'Degree Of Saturation Sr Calc Methods',
            moduleStateSlotName: 'default-geo-sections-degreeofsaturationsrcalculationmethod-browser',
        };

        this.editor = {
            name: 'default-geo-sections-degreeofsaturationsrcalculationmethod-editor',
            moduleName: 'default-geo-sections-degreeofsaturationsrcalculationmethod-editor',
            moduleTitle: 'Degree Of Saturation Sr Calc Method',
            moduleStateSlotName: 'default-geo-sections-degreeofsaturationsrcalculationmethod-editor',
        };

        this.fieldDefs = [
            {
                name: 'id',
                type: 'int',
                persistent: true,
                label: '#ID',
                primaryKey: true,
                required: true,
                readOnly: true,
            },
            {
                name: 'code',
                type: 'string',
                persistent: true,
                label: 'Code',
                required: true,
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'name',
                type: 'string',
                persistent: true,
                label: 'Name',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'description',
                type: 'text',
                persistent: true,
                label: 'Description',
                inEditor: true,
                filterable: true,
            },
            {
                name: 'notes',
                type: 'text',
                persistent: true,
                label: 'Notes',
                inEditor: true,
                filterable: true,
            },
            {
                name: 'isDisabled',
                type: 'bool',
                persistent: true,
                label: 'Is Disabled',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'displayPosition',
                type: 'int',
                persistent: true,
                label: 'Display Position',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'displayLabel',
                type: 'string',
                persistent: false,
                label: 'Display Label',
                readOnly: true,
            },
            {
                name: 'displayDisabled',
                type: 'bool',
                persistent: false,
                label: 'Display Disabled',
                readOnly: true,
            },
        ];

    }

}
